import { z } from "zod";

export const formSchema = z.object({
    integration: z.string(),
});

export type ModifyIntegrationFormData = z.infer<typeof formSchema>;
